
import { Component, Vue, Prop } from "vue-property-decorator";
import { ImagePreview } from "vant";
@Component
export default class Tabs extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  public data;
  public active = 0;
  public HandleclickImg(index, list) {
    ImagePreview({
      images: list,
      closeable: true,
      startPosition: index,
    });
  }
}
